import type { AppState } from '..'

export const selectPresetDenominations = (state: AppState) => {
  return state.betslip.config.presetKeypadAmounts
}

export const selectShouldAllowPendingBetShare = (state: AppState) =>
  state.betslip.config.shouldAllowPendingBetShare
